import React from 'react';

const PauseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="21" width="21" viewBox="5 5 10 10">
    <path d="M11.292 14.75V5.25H14.75V14.75ZM5.25 14.75V5.25H8.708V14.75Z" />
  </svg>
);

export default PauseIcon;
